<div class="flex flex-col py-3 px-6 gap-1">
  <label class="text-xs font-medium text-gray-900">{{ label }}</label>
  <ng-content></ng-content>
</div>
